import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// === Import Images ===
import card from "./card3.png";
import cardd from "./card1.png";
import three from "./fivee.png";
import four from "./card5.png";
import five from "./card2.png";
import six from "./card4.png";

const Card = () => {
  const [activeTab, setActiveTab] = useState("job");

  const certifications = [
    {
      title: "CJCA",
      subtitle: "HTB Certified Junior Cybersecurity Associate",
      modules: 20,
      jobRole: "Junior Cybersecurity Analyst",
      price: "$490",
      image: card,
    },
    {
      title: "CPTS",
      subtitle: "HTB Certified Penetration Testing Specialist",
      modules: 28,
      jobRole: "Penetration Tester",
      price: "$490",
      image: cardd,
    },
    {
      title: "CWEE",
      subtitle: "HTB Certified Web Exploitation Expert",
      modules: 15,
      jobRole: "Senior Web Penetration Tester",
      price: "$1260",
      image: five,
    },
    {
      title: "CBBH",
      subtitle: "HTB Certified Bug Bounty Hunter",
      modules: 20,
      jobRole: "Bug Bounty Hunter",
      price: "$490",
      image: three,
    },
    {
      title: "COSA",
      subtitle: "HTB Certified Defensive Security Analyst",
      modules: 15,
      jobRole: "SOC Analyst",
      price: "$490",
      image: four,
    },
    {
      title: "CAPE",
      subtitle: "HTB Certified Active Directory Pentesting Expert",
      modules: 15,
      jobRole: "Active Directory Penetration Tester",
      price: "$1260",
      image: six,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 768, // tablet & mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-800 via-blue-900 to-red-950 text-white py-12 px-4">
      {/* === Tabs === */}
      <div className="flex justify-center gap-4 mb-6">
        <button
          onClick={() => setActiveTab("job")}
          className={`px-5 py-2 rounded-lg font-semibold transition-all ${
            activeTab === "job"
              ? "bg-red-500 text-white shadow-lg"
              : "bg-blue-950 text-gray-300 hover:bg-blue-900"
          }`}
        >
          👤 JOB ROLE PATHS
        </button>
        <button
          onClick={() => setActiveTab("skill")}
          className={`px-5 py-2 rounded-lg font-semibold transition-all ${
            activeTab === "skill"
              ? "bg-red-500 text-white shadow-lg"
              : "bg-blue-950 text-gray-300 hover:bg-blue-900"
          }`}
        >
          🗝️ SKILL PATHS
        </button>
      </div>

      {/* Heading */}
      <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-10">
        Get MAD Certified
      </h1>

      {/* === Cards Slider === */}
      <div className="max-w-4xl mx-auto">
        <Slider {...settings}>
          {certifications.map((cert, index) => (
            <div key={index} className="p-4">
              <div className="bg-blue-950/80 border border-red-600 rounded-2xl overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-transform duration-300 flex flex-col">
                <img
                  src={cert.image}
                  alt={cert.title}
                  className="w-full h-56 object-cover"
                />
                <div className="p-6">
                  <h2 className="text-2xl font-bold mb-1">{cert.title}</h2>
                  <p className="text-gray-300 text-sm mb-3">{cert.subtitle}</p>

                  <div className="flex justify-between text-gray-400 text-sm mb-3">
                    <p>📘 {cert.modules} Modules</p>
                    <p>📝 Exam Included</p>
                  </div>

                  <div className="text-gray-300 text-sm mb-3">
                    Related Job Role Path: <br />
                    <span className="text-white font-semibold">
                      {cert.jobRole}
                    </span>
                  </div>

                  <p className="text-right text-lg font-semibold text-red-400">
                    Get certified for {cert.price}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Card;
